import Siema from 'siema';

export default class SiemaPatched extends Siema {
  constructor(...args) {
    super(...args);

    this.x5ScreenWidth = window.innerWidth;
  }

  resizeHandler(...args) {
    const screenWidth = window.innerWidth;

    if (screenWidth !== this.x5ScreenWidth) {
      this.x5ScreenWidth = screenWidth;
      super.resizeHandler(...args);
    }
  }
}
